import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { elementDesc } from "@/config/dataMap";
import ResultComponent from "./resultComponent";

interface calculateTask3DYCZProps {
    input: any;
    transInput: any;
    results: any;
}

export default function CalculateTask3DYCZ({
    input,
    transInput,
    results,
}: calculateTask3DYCZProps) {
    const [selectTreeButton, setSelectTreeButton] = useState<any>({});
    const [treeButtons, setTreeButtons] = useState<any[]>([]);
    const scrollViewRef = useRef<HTMLDivElement>(null);



    useEffect(() => {
        const analyInputData = () => {
            if (!results) return;
            if (results.elements?.length) {
                // 用来存 { label: 显示名, name: 设备名, type: 设备类型 }
                const buttonList = [];

                // 1. 先处理 input 里的 DistilStrict
                const distilItems = input?.inputs?.elements?.filter((item: any) => item?.type === "DistilStrict" && input?.inputs.selected_blocks.includes(item?.name)) || [];
                distilItems.forEach((item: any) => {
                    const label = `${item.name} (${elementDesc[item.name] || ''})`;
                    buttonList.push({
                        label: label,        // 页面显示用
                        name: item.name,     // 真实设备名
                        type: item.type      // 你要的 type 
                    });
                });

                // 2. 合并 results 里的设备
                results.elements.forEach((item: any) => {
                    const label = `${item.name} (${elementDesc[item.name] || ''})`;
                    // 去重判断
                    const exist = buttonList.some(b => b.label === label);
                    if (!exist) {
                        buttonList.push({
                            label: label,
                            name: item.name,
                            type: item.type
                        });
                    }
                });

                setTreeButtons(buttonList);
                // 4. 默认选中第一个（只存 name，方便后续查类型）
                if (buttonList.length > 0) {
                    setSelectTreeButton(buttonList[0]);
                }
            }
        };

        analyInputData();
    }, [results, input]);

    // 渲染侧边栏按钮列表 (PC 端默认显示)
    const renderItem1 = (item: any) => (
        <div className="tree-button-item" key={item.name}>
            <button
                onClick={() => {
                    setSelectTreeButton(item)
                }
                }
                className={`tree-button ${selectTreeButton.name === item.name ? "active" : ""
                    }`}
            >
                {/* 设备名（中文名）备份 */}
                {/* <span className="tree-button-text">{item.label}</span> */}
                <span className="tree-button-text">{item.name}</span>
            </button>
        </div>
    );


    // 空数据判断
    if ((!input || !results || !transInput) && selectTreeButton === "" && treeButtons.length === 0) {
        return null;
    }

    return (
        <div className="calculate-task-container">
            {/* PC 端固定显示侧边栏按钮列表 */}
            <div className="sidebar">
                <div className="sidebar-scroll">
                    {treeButtons.map(renderItem1)}
                </div>
            </div>

            {/* 主内容区域 */}
            <div
                className="main-content"
                ref={scrollViewRef}
            >
                {/* 结果组件区域 */}
                <div className="result-content">
                    <ResultComponent
                        scrollViewRef={scrollViewRef}
                        input={input}
                        transInput={transInput}
                        results={results}
                        selectTreeButton={selectTreeButton}
                    />
                </div>
            </div>

        </div>
    );
}